import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { DeviceConfiguration } from './types';

export function getDeviceConfiguration() {
  return queryClient.getQueryData<DeviceConfiguration>(queryKeys.configuration);
}
